exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".needs-analysis-stacked-button{display:flex;flex:1;height:136px}.needs-analysis-stacked-button .quote-needs-button{display:flex;flex-direction:column;flex:1;height:100%;padding:9px 20px;border-radius:6px;box-shadow:0 2px 3px 0 rgba(0,0,0,.161)}.needs-analysis-stacked-button .quote-needs-button [class*=MuiButton-label]{flex-direction:column;justify-content:flex-start}.needs-analysis-stacked-button .quote-needs-button .tool-name{margin:16px 0;font-size:16px;font-weight:700;color:rgba(0,0,0,.871);text-transform:capitalize}.needs-analysis-stacked-button .quote-needs-button .name{font-weight:700;font-size:14px;line-height:17px;letter-spacing:-0.07px;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Tools/NeedsAnalysis/NeedsAnalysisStackedButton.scss
// module id = 8052
// module chunks = 13